function countSurrogateStr(str) {
  let arr = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g) || [];
  return arr.length;
}
export default countSurrogateStr;
